import { Empty } from 'antd';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../store/rootReducer';
import { commaSeperator } from '../../../../../utils/validation';
import CurrencyBar from '../CurrencyBar';
import InvestmentDealType from '../DealType';
import WorldMap from '../WorldMap';

type Props = {
    showWorld?: boolean;
    isPdf?: boolean;
};

const TotalInvested: React.FC<Props> = ({ isPdf }) => {
    const invested = useSelector((state: RootState) => state.investments.aggregate?.invested);
    const currencyDataLength = invested?.currency && Object.keys(invested?.currency).length;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const gridView = {
        parent: `grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6`,
        currency: 'lg:col-span-1 col-span-3',
        geoGraphy: 'col-span-2 h-full',
        outstandingBanner: 'col-span-2 full',
    };

    // if (currencyDataLength >= 4 && currencyDataLength <= 6) {
    //     gridView.currency = 'lg:col-span-2 col-span-3';
    //     gridView.parent = 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4';
    //     gridView.geoGraphy = 'col-span-4 h-full';
    //     gridView.outstandingBanner = 'col-span-4 full';
    // }
    const chartUI = useMemo(() => {
        return (
            <>
                {' '}
                {isPdf && invested?.deal && (
                    <div className={gridView.outstandingBanner}>
                        <div className={`bg-white p-2 gap-1 h-full w-full  flex flex-col justify-center`}>
                            <p className="text-[#182D4F] WorkSans font-semibold text-2xl">
                                {commaSeperator(String(invested?.deal.totalDebtInvested.amountUpto2dp || 0))}
                            </p>
                            <div className="h-[1px] w-full bg-[#27AE60]" />
                            <p className="WorkSans text-xs text-[#152C52]">
                                Total Investment{' '}
                                <span className="text-[#182D4F80] text-[10px]">
                                    &nbsp; ({invested?.deal.totalDebtInvested.currency})
                                </span>
                            </p>
                        </div>
                    </div>
                )}
                {isPdf && currencyDataLength > 0 && (
                    <div className="mt-2 flex justify-between gap-1">
                        <div className="w-[50%]">
                            <InvestmentDealType
                                title="By Deal Type (in USD)"
                                data={[
                                    {
                                        name: 'Debt',
                                        value: invested?.deal?.totalDebtInvested.amountUpto2dp || 0,
                                        fill: '#41D17E',
                                    },
                                    {
                                        name: 'Equity',
                                        value: invested?.deal?.totalEquityInvested.amountUpto2dp || 0,
                                        fill: '#27AE60',
                                    },
                                    {
                                        name: 'Fund',
                                        value: invested?.deal?.totalFundInvested.amountUpto2dp || 0,
                                        fill: '#136E39',
                                    },
                                ].sort((a, b) => a.value - b.value)}
                            />
                        </div>
                        <div className="w-[50%]">
                            <CurrencyBar
                                isPdf={isPdf}
                                title="By Currency"
                                data={Object.keys(invested?.currency)
                                    .map((key) => {
                                        return { name: key, value: invested?.currency[key]?.amountUpto2dp || 0 };
                                    })
                                    .sort((a, b) => b.value - a.value)}
                            />
                        </div>
                    </div>
                )}
                {!isPdf && invested?.deal && (
                    <div className={isPdf ? 'mt-6' : 'lg:col-span-1 col-span-2 h-full'}>
                        <InvestmentDealType
                            title="By Deal Type (in USD)"
                            data={[
                                {
                                    name: 'Debt',
                                    value: invested?.deal?.totalDebtInvested.amountUpto2dp || 0,
                                    fill: '#41D17E',
                                },
                                {
                                    name: 'Equity',
                                    value: invested?.deal?.totalEquityInvested.amountUpto2dp || 0,
                                    fill: '#27AE60',
                                },
                                {
                                    name: 'Fund',
                                    value: invested?.deal?.totalFundInvested.amountUpto2dp || 0,
                                    fill: '#136E39',
                                },
                            ].sort((a, b) => a.value - b.value)}
                        />
                    </div>
                )}
                {!isPdf && currencyDataLength > 0 && (
                    <div className={`${gridView.currency} flex flex-col justify-between items-center gap-6`}>
                        <CurrencyBar
                            isPdf={isPdf}
                            title="By Currency"
                            data={Object.keys(invested?.currency)
                                .map((key) => {
                                    return { name: key, value: invested?.currency[key]?.amountUpto2dp || 0 };
                                })
                                .sort((a, b) => b.value - a.value)}
                        />
                    </div>
                )}
            </>
        );
    }, [isPdf, invested, currencyDataLength, gridView]);
    return (
        <>
            <div className={`grid ${isPdf ? 'grid-cols-3 gap-2' : gridView.parent}  h-full w-full`}>
                {isPdf ? <div className="col-span-2">{chartUI}</div> : chartUI}
                {invested?.geography && Object.keys(invested?.geography).length > 0 && (
                    <div className={isPdf ? 'col-span-1' : gridView.geoGraphy}>
                        <WorldMap
                            data={Object.keys(invested?.geography).map((key) => {
                                return {
                                    name: key,
                                    key: key,
                                    investment: invested?.geography[key]?.amountUpto2dp || 0,
                                };
                            })}
                            isPdf={isPdf}
                        />
                    </div>
                )}
            </div>
            {!invested && (
                <div className="pb-4">
                    <Empty description="No Total Invested" />
                </div>
            )}
        </>
    );
};

export default TotalInvested;
